export const GET_INTERVIEWERS = "GET_INTERVIEWERS";
export const GET_INTERVIEWERS_SUCCESS = "GET_INTERVIEWERS_SUCCESS";
export const GET_INTERVIEWERS_ERROR = "GET_INTERVIEWERS_ERROR";
export const POST_INTERVIEW_DETAILS = "POST_INTERVIEW_DETAILS";
export const POST_INTERVIEW_DETAILS_SUCCESS = "POST_INTERVIEW_DETAILS_SUCCESS";
export const POST_INTERVIEW_DETAILS_ERROR = "POST_INTERVIEW_DETAILS_ERROR";
export const VIDEO_INTERVIEW = "VIDEO_INTERVIEW";
export const ADD_INTERVIEWER = "ADD_INTERVIEWER";
export const ADD_INTERVIEWER_SUCCESS = "ADD_INTERVIEWER_SUCCESS";
export const ADD_INTERVIEWER_ERROR = "ADD_INTERVIEWER_ERROR";
export const RESCHEDULE_INTERVIEW = "RESCHEDULE_INTERVIEW";
export const RESCHEDULE_INTERVIEW_SUCCESS = "RESCHEDULE_INTERVIEW_SUCCESS";
export const RESCHEDULE_INTERVIEW_FAILURE = "RESCHEDULE_INTERVIEW_FAILURE";
export const POST_ABOUT_INTERVIEW = "POST_ABOUT_INTERVIEW";

export const GET_INTERVIEW_ROUNDS_SUCCESS = "GET_INTERVIEW_ROUNDS_SUCCESS";
export const GET_INTERVIEW_ROUNDS_FAILURE = "GET_INTERVIEW_ROUNDS_FAILURE";
export const GET_INTERVIEW_ROUNDS = "GET_INTERVIEW_ROUNDS";

export const GET_HIRE_CANDIDATE_SUCCESS = "GET_HIRE_CANDIDATE_SUCCESS";
export const GET_HIRE_CANDIDATE_FAILURE = "GET_HIRE_CANDIDATE_FAILURE";
export const GET_HIRE_CANDIDATE = "GET_HIRE_CANDIDATE";

export const SAVE_HIRE_CANDIDATE_DATA = "SAVE_HIRE_CANDIDATE_DATA";
export const SAVE_HIRE_CANDIDATE_DATA_FAILURE =
  "SAVE_HIRE_CANDIDATE_DATA_FAILURE";
export const SAVE_HIRE_CANDIDATE_DATA_SUCCESS =
  "SAVE_HIRE_CANDIDATE_DATA_SUCCESS";

export const OFFER_LETTER_TYPE = "OFFER_LETTER_TYPE";
export const OFFER_LETTER_TYPE_FAILURE = "OFFER_LETTER_TYPE_FAILURE";
export const OFFER_LETTER_TYPE_SUCCESS = "OFFER_LETTER_TYPE_SUCCESS";

export const GEN_OFFER_LETTER = "GEN_OFFER_LETTER";
export const GEN_OFFER_LETTER_FAILURE = "GEN_OFFER_LETTER_FAILURE";
export const GEN_OFFER_LETTER_SUCCESS = "GEN_OFFER_LETTER_SUCCESS";

export const GET_GEN_OFFER_LETTER_DETAIL = "GET_GEN_OFFER_LETTER_DETAIL";
export const GET_GEN_OFFER_LETTER_DETAIL_FAILURE =
  "GET_GEN_OFFER_LETTER_DETAIL_FAILURE";
export const GET_GEN_OFFER_LETTER_DETAIL_SUCCESS =
  "GET_GEN_OFFER_LETTER_DETAIL_SUCCESS";

export const GET_EDIT_GEN_OFFER_LETTER_DETAILS =
  "GET_EDIT_GEN_OFFER_LETTER_DETAILS";
export const GET_EDIT_GEN_OFFER_LETTER_DETAILS_SUCCESS =
  "GET_EDIT_GEN_OFFER_LETTER_DETAILS_SUCCESS";
export const GET_EDIT_GEN_OFFER_LETTER_DETAILS_FAIL =
  "GET_EDIT_GEN_OFFER_LETTER_DETAILS_FAIL";

//Video Integration Hireneuron
export const HIRENEURON_VIDEO_INTEGRATION = "HIRENEURON_VIDEO_INTEGRATION";
export const HIRENEURON_VIDEO_INTEGRATION_FAIL =
  "HIRENEURON_VIDEO_INTEGRATION_FAIL";
export const HIRENEURON_VIDEO_INTEGRATION_SUCCESS =
  "HIRENEURON_VIDEO_INTEGRATION_SUCCESS";
